export default {"src":"/_next/static/image/public/images/ic-guestuser-address.f921e0a069bd10fa2ab506483de78faf.svg","height":152,"width":153};